<script lang="ts">
	import { onMount, onDestroy } from "svelte";
	import "maplibre-gl/dist/maplibre-gl.css";
	import maplibregl, { ResourceType } from "maplibre-gl";
	import { bbox } from "@turf/bbox";
	import { yyyy, zzzz } from "../store.svelte";
	import gRC from "./extras/getRandomCoords.svelte"
	import positron from "./extras/positron.svelte";

	interface mapprops {
		g: string;
		wireident: string;
	}
	let { g, wireident }: mapprops = $props();
	//console.log(">>>>", wireident);


	let mappy: string = "map_" + wireident;
	const uri: string = yyyy.uri.api;
	let map = null;

	onMount(() => {
		map = new maplibregl.Map({
			container: mappy,
			maxZoom: 25,
			style: positron,
			center: gRC(), // starting position [lng, lat]
			attributionControl: false,
			zoom: 2, // starting zoom
			interactive: false,
		});

		map.on("load", () => {
			//console.log("map loaded");
			//console.log(g);

			map.addSource("aoi", { type: "geojson", data: g });

			map.addLayer({
				id: "aoi",
				type: "line",
				source: "aoi",
				layout: {
					"line-join": "round",
					"line-cap": "round",
				},
				paint: {
					"line-color": "#ff3e00",
					"line-width": 2,
					"line-dasharray": [10, 1],
					//"line-gap-width": 15,
				},
			});
			map.fitBounds(bbox(g), {
				padding: { top: 25, bottom: 25, left: 25, right: 25 },
			});
		});
	});

	onDestroy(() => {
		if (map) {
			map.remove(); // Properly destroy the WebGL context
			map = null;
		}
	});
</script>

<div id={mappy} class="card-maplibre-map" style="height: 100%;"></div>

<style>
	/* .card-maplibre-map { */
	/* 	position: relative; */
	/* 	background-color: black; */
	/* 	height: 100%; */
	/* } */
</style>
